import { EventFeedType } from '@toggle/toggle';

import {
  STREAM_SELECTED_WATCHLISTS,
  useRemoteStorage,
} from '~/hooks/use-remote-storage';
import { create } from '~/utils/store/createStore';

export type StreamFilterTabs =
  | 'all'
  | 'catalysts'
  | 'scenarios'
  | 'earnings'
  | 'summaries';

export const tabTypeToEventFeedType: Record<
  StreamFilterTabs,
  EventFeedType | undefined
> = {
  all: undefined,
  catalysts: 'attribution-insight',
  scenarios: 'scenario-insight',
  earnings: 'earnings-insight',
  summaries: 'market-overview',
};
interface StreamFiltersStore {
  selectedWatchlistIds: Set<string>;
  isSecondRelationshipEnabled: boolean;
  selectedTabType: StreamFilterTabs;
  isInitialized: boolean;
  initializeFromStorage: () => void;
  setSelectedWatchlistIds: (ids: Set<string>) => void;
  setIsSecondRelationshipEnabled: (enabled: boolean) => void;
  handleToggleSecondRelationship: () => void;
  setSelectedTabType: (type: StreamFilterTabs) => void;
}

export const useStreamFilters = create<StreamFiltersStore>(set => ({
  selectedWatchlistIds: new Set<string>(),
  isSecondRelationshipEnabled: false,
  selectedTabType: 'all',
  isInitialized: false,
  initializeFromStorage: () => {
    const { items } = useRemoteStorage.getState();
    const storedIds = Array.isArray(items?.[STREAM_SELECTED_WATCHLISTS])
      ? items?.[STREAM_SELECTED_WATCHLISTS]
      : undefined;

    if (storedIds?.length) {
      set({ selectedWatchlistIds: new Set(storedIds), isInitialized: true });
    } else {
      set({ isInitialized: true });
    }
  },
  setSelectedWatchlistIds: ids => {
    set({ selectedWatchlistIds: ids });

    const { storeItems } = useRemoteStorage.getState();
    storeItems({ [STREAM_SELECTED_WATCHLISTS]: Array.from(ids) });
  },
  setIsSecondRelationshipEnabled: enabled => {
    set({ isSecondRelationshipEnabled: enabled });
  },
  handleToggleSecondRelationship: () => {
    set(state => ({
      isSecondRelationshipEnabled: !state.isSecondRelationshipEnabled,
    }));
  },
  setSelectedTabType: type => {
    set({ selectedTabType: type });
  },
}));
